"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyGivenPennies = exports.convertFromPennies = exports.convertToPennies = exports.getParameterByName = exports.isField = exports.toIsoDateTime = exports.toIsoDate = exports.parseIsoDateTime = exports.parseDate = exports.parseIsoDate = exports.now = exports.isNotEmpty = exports.capitalize = exports.isEmpty = exports.redirectToLogin = exports.redirectToOrgPrograms = exports.currentBaseUrl = exports.isLocal = void 0;
var luxon_1 = require("luxon");
var lodash_1 = require("lodash");
var constants_1 = require("./constants");
function isLocal() {
    return (window.location.href.indexOf("http://localhost:") == 0 ||
        window.location.href.indexOf("https://ts-checkr.ngrok.io") == 0);
}
exports.isLocal = isLocal;
function currentBaseUrl() {
    var _a = window.location, protocol = _a.protocol, host = _a.host;
    return protocol + "//" + host;
}
exports.currentBaseUrl = currentBaseUrl;
function redirectToOrgPrograms(orgId) {
    window.location.href = currentBaseUrl() + "/organizations/" + orgId + "/programs";
}
exports.redirectToOrgPrograms = redirectToOrgPrograms;
function redirectToLogin(redirectUrl) {
    redirectUrl = redirectUrl || window.location.href;
    window.location.href = constants_1.COGSWORTH_URL + "login?client_id=" + constants_1.CLIENT_ID + "&redirect_uri=" + redirectUrl;
}
exports.redirectToLogin = redirectToLogin;
function isEmpty(value) {
    return !value || value.trim() == "";
}
exports.isEmpty = isEmpty;
function capitalize(value) {
    if (isEmpty(value))
        return value;
    return value.substring(0, 1).toUpperCase() + value.substring(1);
}
exports.capitalize = capitalize;
function isNotEmpty(value) {
    return !isEmpty(value);
}
exports.isNotEmpty = isNotEmpty;
function now() {
    return luxon_1.DateTime.local();
}
exports.now = now;
function parseIsoDate(date) {
    if (!date || date.length < 10)
        return null;
    if (date.length > 10) {
        date = date.substring(0, 10);
    }
    return luxon_1.DateTime.fromISO(date);
}
exports.parseIsoDate = parseIsoDate;
function parseDate(date, format) {
    if (!date)
        return null;
    return luxon_1.DateTime.fromFormat(date, format);
}
exports.parseDate = parseDate;
function parseIsoDateTime(date) {
    return luxon_1.DateTime.fromISO(date);
}
exports.parseIsoDateTime = parseIsoDateTime;
function toIsoDate(dateTime) {
    if (!dateTime)
        return null;
    return dateTime.toString().substring(0, 10);
}
exports.toIsoDate = toIsoDate;
function toIsoDateTime(dateTime) {
    if (!dateTime)
        return null;
    return dateTime.toString();
}
exports.toIsoDateTime = toIsoDateTime;
function isField(object, key, prototype) {
    if (!prototype) {
        prototype = Object.getPrototypeOf(object);
    }
    if (lodash_1.isFunction(object[key]))
        return false;
    var desc = Object.getOwnPropertyDescriptor(prototype, key);
    var hasGetter = desc && typeof desc.get === "function";
    return !hasGetter;
}
exports.isField = isField;
function getParameterByName(url, name) {
    if (!url)
        url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
exports.getParameterByName = getParameterByName;
function convertToPennies(value) {
    var pennies = value.trim().replace("$", "");
    return pennies ? +Number(pennies).toFixed(2) * 100 : pennies;
}
exports.convertToPennies = convertToPennies;
function convertFromPennies(value) {
    if (value == 0) {
        return Number(value).toFixed(2);
    }
    return value ? Number(value / 100).toFixed(2) : value;
}
exports.convertFromPennies = convertFromPennies;
function currencyGivenPennies(value) {
    var isNegative = value < 0;
    var dollars = convertFromPennies(Math.abs(value));
    if (isNegative) {
        return "(-$" + dollars + ")";
    }
    return "$" + dollars;
}
exports.currencyGivenPennies = currencyGivenPennies;
//# sourceMappingURL=utils.js.map